import { render, staticRenderFns } from "./NotifCommentPostICommented.vue?vue&type=template&id=265ec7c0"
import script from "./NotifCommentPostICommented.vue?vue&type=script&lang=js"
export * from "./NotifCommentPostICommented.vue?vue&type=script&lang=js"
import style0 from "./NotifStyle.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports